import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  border: 1px solid var(--secondary-gray);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 20px;
`;

const BorderedContainer = ({ children, ...props }, ref) => (
  <Container ref={ref} {...props}>
    {children}
  </Container>
);

export default React.forwardRef(BorderedContainer);
